/**
 * Logica per visualizzazione bottone "Segna tutte come lette"
 */
export class ReadAllNotificationsLogic {
  /**
   * Ritorna vero se la configurazione non richiede di nascondere
   * le funzionalità relative alla visualizzazione del bottone "Segna tutte come lette".
   * (gestisce solo UI)
   */
  static isVisible() {
    return process.env.SHOW_MARK_ALL_NOTIFICATIONS_AS_READ === 'true';
  }
}
